/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { GlobalConfiguration } from "../../../../../utils/configurationProvider";
import globalText from "../../../../../utils/globalText";
import { globalTextFormat } from "../../../../../utils/globalTextFormat";
import AssignLabels from "../../../../_utils/AccountCreationComponents/AssignLabels";
import CommonLayout from "../../../../_utils/CommonLayout";
import CommonAssignLabelPopup from "../../../../_utils/CommonPopups/CommonAssignLabelPopup";
import CategorySelector from "../../../../_utils/TransactionCommonComponents/CategorySelector";
import DynamicAdditionalFields from "../../../../_utils/TransactionCommonComponents/DynamicAdditionalFields";

const formatUIDate = (date) => {
  if (!date) return "";
  const d = new Date(date);
  return `${d.getDate()} ${d.toLocaleString("en-US", { month: "short" })}, ${d.getFullYear()}`;
};
const BeneficiaryTransactionStepAdditionalDetails = ({
  txnPayLoad,
  setInitialRefactorAdditionalDetail,
  setQuantities,
  setTxnPayLoad,
  copyData,
  setAdditionalData,
  additionalData,
  setTimeData,
  setCopyData,
  setStartDate,
  setSelectedValueMonth,
  setSelectedValue,
  initialRefactorAdditionalDetail,
  setHyperLink,
  hyperLink,
  selectedValue,
  timeData,
  quantities,
  uploadedFiles,
  previewImages,
  selectedValueMonth,
  setPreviewImages,
  setUploadedFiles,
  startDate,
  endDate,
  setEndDate,
  beneAccountId,
  categories,
  category,
  selectedCategory,
  setSelectedCategory,
}) => {
  const labelActionDispatchedRef = useRef(false);
  const [isCategoryLoading, setIsCategoryLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showLabelModal, setShowLabelModal] = useState(false);
  const [selectedLabelsCreate, setSelectedLabelsCreate] = useState(() => {
    const initialLabels = [
      ...(txnPayLoad?.labels || []),
      ...(txnPayLoad?.ownerLabels || []),
    ];
    return [...new Set(initialLabels)];
  });
  const [labels, setLabels] = useState(() => {
    const initialLabels = [
      ...(txnPayLoad?.labels || []),
      ...(txnPayLoad?.ownerLabels || []),
    ];
    return [...new Set(initialLabels)];
  });

  const navigate = useNavigate();

  const disableCategories = true;

  useEffect(() => {
    if (!isCategoryLoading) return;

    if (selectedCategory?.configuration?.data && txnPayLoad?.mergeCategory) {
      setIsCategoryLoading(false);
    }
  }, [isCategoryLoading, selectedCategory, txnPayLoad?.mergeCategory]);

  const safeCategories = Array.isArray(categories) ? categories : [];

  const unassignCategories = safeCategories.filter(
    (cat) => cat?.active === "Y",
  );

  const unassignlength = unassignCategories.filter(
    (unassignCategory) => !category?.includes(unassignCategory?.id),
  );

  const isCategorySelected = !!selectedCategory;

  const handleUnassignNavigate = (id) => {
    navigate(
      `/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/edit_categories/${id}`,
      { replace: false },
    );
  };
  const handleCategorySelect = (categoryId) => {
    const categoryData = safeCategories.find((c) => c.id === categoryId);
    const isAssigned = category?.includes(categoryId);
    if (!categoryData || categoryData?.active !== "Y" || !isAssigned) {
      setSelectedCategory(null);

      setTxnPayLoad((prev) => ({
        ...prev,
        selectedCategory: null,
        mergeCategory: null,
      }));

      setAdditionalData({});
      return;
    }

    // First render: show loader
    setIsCategoryLoading(true);

    // Clear old fields immediately
    setTxnPayLoad((prev) => ({
      ...prev,
      mergeCategory: null,
    }));

    setAdditionalData({});
    setSelectedValue({ from: "Select", to: "Select" });
    setStartDate({});
    setEndDate({});
    setHyperLink({});
    setPreviewImages({});
    setUploadedFiles({});
    setTimeData({});
    setQuantities({});
    setSelectedValueMonth({});

    // Second render: set new category + fields
    requestAnimationFrame(() => {
      setSelectedCategory(categoryData);

      setTxnPayLoad((prev) => ({
        ...prev,
        selectedCategory: categoryData,
        mergeCategory: categoryData?.configuration?.data || [],
      }));

      setIsCategoryLoading(false);
    });
  };

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const handleQuantityChange = (value, fieldname, data_type, key) => {
    if (value < 0 || String(value).length > 15) return;

    const numVal = value === "" ? "" : Number(value);

    setInitialRefactorAdditionalDetail((prev) => ({
      ...prev,
      [fieldname]: {
        ...prev[fieldname],
        isCopyDirect: false,
        isCopyClick: false,
      },
    }));

    setQuantities((prev) => ({
      ...prev,
      [key]: numVal,
    }));

    handleInputChange({
      target: {
        name: fieldname,
        value: numVal,
        data_typeChan: data_type,
      },
    });
  };

  const handleTimeConfirm = (
    fieldname,
    data_type,
    hourShow,
    minuteShow,
    meridiemShow,
  ) => {
    handleInputChange({
      target: {
        name: fieldname,
        value: `${hourShow}:${minuteShow} ${meridiemShow}`,
        data_typeChan: data_type,
      },
    });
  };

  const handleInputChange = (e) => {
    if (e?.preventDefault) e.preventDefault();

    const name = e?.target?.name ?? e?.name;
    const value = e?.target?.value ?? e?.value;

    const field = txnPayLoad?.selectedCategory?.configuration?.data?.find(
      (f) => f.name === name,
    );

    if (!field) return;

    let updatedData = { ...additionalData };

    switch (field.data_type) {
      case "month_year": {
        if (value?.month && value?.year) {
          const monthNumber = (
            months.indexOf(value.month) + GlobalConfiguration?.lengthCheckOne
          )
            .toString()
            .padStart(2, "0");
          updatedData[name] = `${monthNumber}/${value.year}`;
        } else {
          updatedData[name] = "";
          setInitialRefactorAdditionalDetail((prev) => ({
            ...prev,
            [name]: { ...prev[name], isCopyDirect: false, isCopyClick: false },
          }));
        }
        break;
      }

      case "from_year_to_year": {
        updatedData[name] = {
          from:
            value?.from !== undefined && value?.from !== ""
              ? Number(value.from)
              : null,
          to:
            value?.to !== undefined && value?.to !== ""
              ? Number(value.to)
              : null,
        };
        break;
      }

      case "date_range": {
        if (!value?.start_date || !value?.end_date) {
          updatedData[name] = null;
        } else {
          updatedData[name] = {
            start_date: value.start_date,
            end_date: value.end_date,
          };
        }
        break;
      }

      case "numeric": {
        const cleaned = String(value)
          .replace(/\D/g, "")
          .slice(
            GlobalConfiguration?.lengthCheckZero,
            GlobalConfiguration?.gstLength,
          );

        updatedData[name] = cleaned;
        break;
      }

      case "quantity": {
        updatedData[name] = Number(value);
        break;
      }

      default: {
        updatedData[name] = value;
      }
    }

    setAdditionalData(updatedData);
  };

  const handleClose = (finalLabels) => {
    setShowLabelModal(false);
    if (!finalLabels) return;

    const currentOwnerLabels = txnPayLoad?.ownerLabels || [];

    const newOwnerLabels = finalLabels?.filter((label) =>
      currentOwnerLabels?.includes(label),
    );
    const newOtherLabels = finalLabels?.filter(
      (label) => !currentOwnerLabels?.includes(label),
    );

    setTxnPayLoad((prevPayload) => ({
      ...prevPayload,
      ownerLabels: newOwnerLabels,
      labels: newOtherLabels,
    }));
  };

  useEffect(() => {
    if (
      copyData?.value !== "" &&
      copyData?.title !== "" &&
      copyData?.data_type === "time"
    ) {
      const timeStr = copyData?.value;
      const [hourShow, rest] = timeStr.split(":");
      const [minuteShow, meridiemShow] = rest.split(" ");

      handleTimeConfirm(
        copyData?.title,
        copyData?.data_type,
        hourShow,
        minuteShow,
        meridiemShow,
      );

      setTimeData((prev) => {
        const key = `${copyData?.title}_${copyData?.data_type}`;
        return {
          ...prev,
          [key]: { hours: hourShow, minutes: minuteShow },
        };
      });

      setCopyData({
        title: "",
        value: "",
        data_type: "",
      });
    } else if (
      copyData?.value !== "" &&
      copyData?.title !== "" &&
      copyData?.data_type === "date"
    ) {
      const key = `${copyData?.title}_${copyData?.data_type}`;
      const rawValue = copyData?.value;

      // Parse the date string robustly
      // Try direct Date parse first, then strip commas as fallback
      let parsedDate = new Date(rawValue);
      if (isNaN(parsedDate.getTime())) {
        parsedDate = new Date(rawValue.replace(",", ""));
      }

      if (!isNaN(parsedDate.getTime())) {
        // Update additionalData with the formatted string (for comparison)
        handleInputChange({
          target: {
            name: copyData?.title,
            value: formatUIDate(parsedDate), // store formatted string in additionalData
            data_typeChan: copyData?.data_type,
          },
        });

        // Update startDate with the actual Date object (for calendar display)
        setStartDate((prev) => ({
          ...prev,
          [key]: parsedDate,
        }));
      }

      setCopyData({
        title: "",
        value: "",
        data_type: "",
      });
    } else if (
      copyData?.value !== "" &&
      copyData?.title !== "" &&
      copyData?.data_type === "quantity"
    ) {
      handleQuantityChange(
        copyData?.value || 0,
        copyData?.title,
        copyData?.data_type,
        `${copyData?.title}_${copyData?.data_type}`,
      );

      setCopyData({
        title: "",
        value: "",
        data_type: "",
      });
    } else if (
      copyData?.value !== "" &&
      copyData?.title !== "" &&
      copyData?.data_type === "toggle"
    ) {
      handleInputChange({
        target: {
          name: copyData?.title,

          value: copyData?.value,

          data_typeChan: copyData?.data_type,
        },
      });

      setCopyData({
        title: "",

        value: "",

        data_type: "",
      });
    } else if (
      copyData?.value !== "" &&
      copyData?.title !== "" &&
      copyData?.data_type === "month_year"
    ) {
      handleInputChange({
        target: {
          name: copyData?.title,

          value: copyData?.value,

          data_typeChan: copyData?.data_type,
        },
      });

      const [monthStr, yearStr] = copyData?.value.split("/");

      const monthIndex = parseInt(monthStr, 10) - 1;

      const monthName = new Date(2000, monthIndex).toLocaleString("default", {
        month: "long",
      });

      const result = [monthName, parseInt(yearStr, 10)];

      setSelectedValueMonth((prev) => {
        const key = `${copyData?.title}_${copyData?.data_type}`;

        return {
          ...prev,

          [key]: { month: result[0], year: result[1] },
        };
      });

      setCopyData({
        title: "",

        value: "",

        data_type: "",
      });
    } else if (
      copyData?.value !== "" &&
      copyData?.title !== "" &&
      copyData?.data_type === "from_year_to_year"
    ) {
      handleInputChange({
        target: {
          name: copyData?.title,

          value: copyData?.value,

          data_typeChan: copyData?.data_type,
        },
      });

      setSelectedValue((prev) => {
        const key = `${copyData?.title}_${copyData?.data_type}`;

        return {
          ...prev,

          [key]: {
            from: copyData?.value?.from,

            to: copyData?.value?.to,
          },
        };
      });

      setCopyData({
        title: "",

        value: "",

        data_type: "",
      });
    } else if (
      copyData?.value !== "" &&
      copyData?.title !== "" &&
      copyData?.data_type === "date_range"
    ) {
      setCopyData({
        title: "",

        value: "",

        data_type: "",
      });
    }
  }, [copyData]);

  useEffect(() => {
    if (!additionalData) return;

    const storeData = txnPayLoad.selectedCategory?.configuration?.data?.map(
      (val) => {
        const dataValue = additionalData[val?.name];

        if (
          dataValue !== undefined &&
          (Array.isArray(dataValue)
            ? dataValue.length > GlobalConfiguration?.lengthCheckZero
            : dataValue !== "")
        ) {
          if (val?.data_type === "numeric") {
            return {
              ...val,
              value: String(dataValue),
            };
          }

          return { ...val, value: dataValue };
        }
        switch (val?.data_type) {
          case "multi_select_list":
            return { ...val, value: [] };

          case "toggle":
            return { ...val, value: false };

          case "hyperlink":
          case "upload":
            return { ...val, value: "" };

          case "time":
            return val;

          default:
            return val?.mandatory !== "Y" ? { ...val, value: "" } : val;
        }
      },
    );

    setTxnPayLoad((prev) => ({
      ...prev,
      mergeCategory: storeData,
    }));
  }, [additionalData, txnPayLoad.selectedCategory]);

  useEffect(() => {
    const labelTxnRaw = sessionStorage.getItem("beneficiaryTxnLabels");
    const accountTxnRaw = sessionStorage.getItem("beneficiaryAccountLabels");

    const txnLabels = labelTxnRaw ? JSON.parse(labelTxnRaw) : [];
    const accounLabels = accountTxnRaw ? JSON.parse(accountTxnRaw) : [];

    const initialLabels = [
      ...(txnPayLoad?.labels || []),
      ...(txnPayLoad?.ownerLabels || []),
      ...txnLabels,
      ...accounLabels,
    ];

    const uniqueLabels = [...new Set(initialLabels)];

    setLabels(uniqueLabels);
  }, []);

  useEffect(() => {
    if (!txnPayLoad) return;

    const ownerLabels = txnPayLoad?.ownerLabels || [];
    const labels = txnPayLoad?.labels || [];

    const combined = [
      ...ownerLabels,
      ...labels.filter((label) => !ownerLabels.includes(label)),
    ];

    setSelectedLabelsCreate(combined);
  }, [txnPayLoad?.ownerLabels, txnPayLoad?.labels]);

  useEffect(() => {
    if (!initialRefactorAdditionalDetail) return;

    Object.entries(initialRefactorAdditionalDetail).forEach(
      ([key, fieldMeta]) => {
        if (fieldMeta?.isCopyClick && fieldMeta?.isPaste) {
          const pasteDataType = fieldMeta?.isPaste?.data_type;

          if (pasteDataType === "hyperlink") {
            const value = fieldMeta.isPaste.value ?? "";
            const fieldKey = `${key}_hyperlink`;

            setHyperLink((prev) => ({
              ...prev,
              [fieldKey]: value,
            }));

            handleInputChange({
              target: {
                name: key,
                value: value,
                data_type: "hyperlink",
              },
            });

            setInitialRefactorAdditionalDetail((prev) => ({
              ...prev,
              [key]: {
                ...prev[key],
                isCopyClick: false,
                isPaste: {},
              },
            }));
          }
        }
      },
    );
  }, [initialRefactorAdditionalDetail]);

  return (
    <>
      {showLabelModal && (
        <div className="fixed left-left-base w-width-full top-top-base h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-max-zindex">
          <CommonAssignLabelPopup
            headerTitle="Assign/unassign labels:"
            headersubtext="Labels will be used to generate statistics for the associated transactions."
            closehandleFunction={handleClose}
            closeisDisabled={false}
            labels={labels}
            setLabels={setLabels}
            isLabelPopupOpen={showLabelModal}
            setPayload={setTxnPayLoad}
            txnPayLoad={txnPayLoad}
            selectedLabelsCreate={selectedLabelsCreate}
            setSelectedLabelsCreate={(x) => {
              setSelectedLabelsCreate(x);
            }}
            labelActionDispatchedRef={labelActionDispatchedRef}
            loading={loading}
            setLoading={setLoading}
            type="create"
          />
        </div>
      )}
      <div
        className="w-width-full Qlg:px-padding-base px-padding-md Qsmd:py-padding-md py-padding-md max-w-tab-width-normal mx-auto"
        style={{ scrollbarWidth: "none" }}
      >
        <CommonLayout>
          <div className="w-width-full lg:max-w-[var(--create-box-width)] pb-padding-md Qsmd:pb-padding-base">
            <CategorySelector
              beneAccountId={beneAccountId}
              category={category}
              selectedCategory={selectedCategory}
              unassignCategories={unassignCategories}
              unassignlength={unassignlength}
              disableCategories={disableCategories}
              handleCategorySelect={handleCategorySelect}
              handleUnassignNavigate={handleUnassignNavigate}
              previewMode={false}
              enableSearch
              showUnassignCTA
            />
          </div>
          <div className="w-width-full lg:max-w-[var(--create-box-width)] flex flex-col gap-gap-md">
            <DynamicAdditionalFields
              headerText={globalTextFormat(
                globalText.CATEGORY_SPECIFIC_DETAILS,
                [0, 1, 2],
              )}
              mergeCategory={txnPayLoad?.mergeCategory}
              isCategoryLoading={isCategoryLoading}
              isCategorySelected={isCategorySelected}
              requiresCategorySelection={true}
              additionalData={additionalData}
              setAdditionalData={setAdditionalData}
              hyperLink={hyperLink}
              setHyperLink={setHyperLink}
              timeData={timeData}
              setTimeData={setTimeData}
              quantities={quantities}
              setQuantities={setQuantities}
              uploadedFiles={uploadedFiles}
              setUploadedFiles={setUploadedFiles}
              startDate={startDate}
              setStartDate={setStartDate}
              endDate={endDate}
              setEndDate={setEndDate}
              selectedValue={selectedValue}
              setSelectedValue={setSelectedValue}
              selectedValueMonth={selectedValueMonth}
              setSelectedValueMonth={setSelectedValueMonth}
              initialRefactorAdditionalDetail={initialRefactorAdditionalDetail}
              setInitialRefactorAdditionalDetail={
                setInitialRefactorAdditionalDetail
              }
              previewImages={previewImages}
              setPreviewImages={setPreviewImages}
              onInputChanged={(name, value, type) => {
                handleInputChange({
                  target: {
                    name,
                    value,
                    data_typeChan: type,
                  },
                });
              }}
            />

            <AssignLabels
              setLabelpopup={setShowLabelModal}
              labels={selectedLabelsCreate}
              subText1={globalText?.LABELS_USAGE_NOTE}
              subText2={globalText?.LABELS_AUTO_ASSIGNED_NOTE}
              isOptional={true}
            />
          </div>
        </CommonLayout>
      </div>
    </>
  );
};

export default BeneficiaryTransactionStepAdditionalDetails;
